import { Phone, PhoneCall, MapPin, MessageCircle, Clock } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import {
  ADDRESS,
  MAP_EMBED_URL,
  PHONE_LANDLINE_DISPLAY,
  PHONE_LANDLINE_TEL,
  PHONE_MOBILE_DISPLAY,
  PHONE_MOBILE_TEL,
  WHATSAPP_BOOKING_URL,
} from "../data/site";

export const Contact = () => (
  <section
    id="contact"
    data-testid="contact-section"
    className="scroll-mt-20 bg-[#E3DECF] py-24 sm:py-28"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading
        eyebrow="Location & Contact"
        title="Visit Us in Al Qusais"
        subtitle="Walk-ins are welcome, though we recommend booking ahead so your chair is always ready."
      />

      <div className="mt-16 grid gap-8 lg:grid-cols-2">
        <Reveal>
          <div className="flex h-full flex-col justify-between rounded-3xl bg-[#383D33] p-8 shadow-2xl sm:p-10">
            <div>
              <h3 className="font-brand text-2xl tracking-wide text-[#F2EFE6]">
                Her Styles Ladies Salon
              </h3>
              <div className="gold-hairline mt-4 h-px w-24" />

              <div className="mt-8 space-y-5">
                <a
                  href={PHONE_MOBILE_TEL}
                  data-testid="contact-phone-mobile-link"
                  className="group flex items-center gap-4"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[rgba(201,162,75,0.5)] text-[#C9A24B] transition-colors duration-300 group-hover:bg-[#C9A24B] group-hover:text-[#383D33]">
                    <Phone className="h-5 w-5" />
                  </span>
                  <span className="font-body text-lg tracking-wider text-[#F2EFE6] transition-colors duration-300 group-hover:text-[#D8C28A] sm:text-xl">
                    {PHONE_MOBILE_DISPLAY}
                  </span>
                </a>

                <a
                  href={PHONE_LANDLINE_TEL}
                  data-testid="contact-phone-landline-link"
                  className="group flex items-center gap-4"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[rgba(201,162,75,0.5)] text-[#C9A24B] transition-colors duration-300 group-hover:bg-[#C9A24B] group-hover:text-[#383D33]">
                    <PhoneCall className="h-5 w-5" />
                  </span>
                  <span className="font-body text-lg tracking-wider text-[#F2EFE6] transition-colors duration-300 group-hover:text-[#D8C28A] sm:text-xl">
                    {PHONE_LANDLINE_DISPLAY}
                  </span>
                </a>

                <div className="flex items-start gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[rgba(201,162,75,0.5)] text-[#C9A24B]">
                    <MapPin className="h-5 w-5" />
                  </span>
                  <p className="pt-2 font-body text-base leading-relaxed text-[#F2EFE6]/85">
                    {ADDRESS}
                  </p>
                </div>

                <div className="flex items-start gap-4" data-testid="contact-opening-hours">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[rgba(201,162,75,0.5)] text-[#C9A24B]">
                    <Clock className="h-5 w-5" />
                  </span>
                  <div className="pt-1.5 font-body text-base leading-relaxed text-[#F2EFE6]/85">
                    <p>Open Daily: 10:00 AM – 9:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <a
                href={WHATSAPP_BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-button"
                className="btn-shimmer flex flex-1 items-center justify-center gap-2.5 rounded-full bg-[#C9A24B] px-6 py-3.5 font-body text-xs font-semibold uppercase tracking-[0.18em] text-[#383D33] transition-colors duration-300 hover:bg-[#D4AF37]"
              >
                <MessageCircle className="h-4 w-4" />
                WhatsApp Us
              </a>
              <a
                href={PHONE_MOBILE_TEL}
                data-testid="contact-call-now-button"
                className="flex flex-1 items-center justify-center gap-2.5 rounded-full border border-[#F2EFE6]/40 px-6 py-3.5 font-body text-xs font-semibold uppercase tracking-[0.18em] text-[#F2EFE6] transition-colors duration-300 hover:border-[#C9A24B] hover:text-[#C9A24B]"
              >
                <Phone className="h-4 w-4" />
                Call Now
              </a>
            </div>
          </div>
        </Reveal>

        <Reveal delay={150}>
          <div className="h-full min-h-[360px] overflow-hidden rounded-3xl border-4 border-[#F5F2EB] shadow-2xl lg:min-h-full">
            <iframe
              src={MAP_EMBED_URL}
              title="Her Styles Ladies Salon location, Al Nazriya Building, Damascus Street, Al Qusais, Dubai"
              data-testid="contact-location-map"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              className="h-full min-h-[360px] w-full border-0"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
